import { useQueryData } from "@src/hooks/useQueryData";
import { arrayIsEmpty } from "@src/helpers/array/arrayIsEmpty";
import { limitCardsServices, type LimitCard } from "@src/api/stock/limitCards";

/**
 * Загрузка карточки лимитной карты (только server-state).
 */
export function useWsLimitCardQuery(limitCardCode: number) {
    return useQueryData<LimitCard>({
        queryKey: ["workshop", "wsLimitCard", limitCardCode, "card"],
        queryFn: async ({ signal }) => {
            const { items } = await limitCardsServices.load(
                {
                    flt: { Codes: [limitCardCode] },
                    include: ["Sender", "SenderSection", "Receiver", "ReceiverSection", "Bo"],
                    includeBo: ["State"],
                },
                { signal },
            );

            if (arrayIsEmpty(items)) {
                throw new Error("Лимитная карта не найдена");
            }

            return items[0];
        },
        enabled: limitCardCode > 0,
        meta: { errorSource: "workshop.wsLimitCard.card" },
    });
}
